/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type AdminAccountsListState = typeof AdminAccountsListState[keyof typeof AdminAccountsListState];


export const AdminAccountsListState = {
  active: 'active',
  all: 'all',
  cancelled: 'cancelled',
  disabled: 'disabled',
  expired: 'expired',
  needs_2fa: 'needs_2fa',
  pending: 'pending',
} as const;
